import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const LOCATION_TYPES_ADDITIONAL_FIELDS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'LOCATION_TYPES_ADDITIONAL_FIELDS'
);
export const LOCATION_TYPES_ADDITIONAL_FIELDS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	LOCATION_TYPES_ADDITIONAL_FIELDS_CRUD_ACTION_CONSTANTS
);
